import { render, staticRenderFns } from "./WarehouseViewDialog.vue?vue&type=template&id=bfcf8252&scoped=true"
import script from "./WarehouseViewDialog.vue?vue&type=script&lang=js"
export * from "./WarehouseViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcf8252",
  null
  
)

export default component.exports